import { useLocation } from "react-router-dom";

import { Paths } from "../../../common/constants";

const useAccountDetailsHelper = () => {
  const location = useLocation();

  const pathName = location.pathname.split("/");
  const sourceId = pathName[pathName.length - 1];

  const breadCrumbItems = [
    { label: "My Accounts", path: Paths.ACCOUNT_LIST },
    { label: `Account Details` },
  ];

  const accountDetailsString = localStorage.getItem("account-details");
  const accountDetails = accountDetailsString
    ? JSON.parse(accountDetailsString)
    : {};

  return {
    sourceId,
    accountDetails,
    breadCrumbItems,
  };
};

export default useAccountDetailsHelper;
